import { isAppspool } from "./isAppspool";
import { isGameverse, isGamiclub } from "./isGamiclub";
import {
  isFunzarena,
  isGamelords,
  isGamesqueens,
  isGameverselt,
  isThegamingclubs,
} from "./productCondition";

const gamiclubSubDomains = ["fr", "ro", "cz", "rs", "pt"];
const gameLordsSubDomains = ["ch", "pt"];
const thegamingclubsSubDomains = ["lt", "si"];
const gamesqueensSubDomains = ["rs"];
const gameverseSubDomains = ["portal"];
const appspoolSubDomains = ["ch"];
const gameverseltSubDomains = ["portal"];
const funzarenaSubDomains = ["pl"];

export const isWithdrawEnabled = (subDomain) =>
  (gamiclubSubDomains.includes(subDomain) && isGamiclub) ||
  (gameLordsSubDomains.includes(subDomain) && isGamelords) ||
  (thegamingclubsSubDomains.includes(subDomain) && isThegamingclubs) ||
  (gamesqueensSubDomains.includes(subDomain) && isGamesqueens) ||
  (gameverseSubDomains.includes(subDomain) && isGameverse) ||
  (appspoolSubDomains.includes(subDomain) && isAppspool) ||
  (gameverseltSubDomains.includes(subDomain) && isGameverselt) ||
  (funzarenaSubDomains.includes(subDomain) && isFunzarena);



// WEBPACK FOOTER //
// ./src/constants/enableWithdraw.js